import { camelize, dasherize } from '@ember/string';

export interface NotificationMessageAttributes {
  hostMessage?: string | null;
  delegatedMessage?: string | null;
  message?: string | null;
  for?: string | null;
  [key: string]: unknown;
}

export default class NotificationMessage {
  hostMessage: string | null = null;
  delegatedMessage: string | null = null;
  message: string | null = null;
  for: string | null = null;

  constructor(attrs: NotificationMessageAttributes) {
    Object.keys(attrs).forEach((key) => {
      const typedKey = key as keyof NotificationMessageAttributes;
      const camelizedKey = camelize(key);
      (this as Record<string, unknown>)[camelizedKey] = attrs[typedKey];
    });
  }

  serialize(): Record<string, unknown> {
    return Object.getOwnPropertyNames(this).reduce<Record<string, unknown>>((acc, key) => {
      acc[dasherize(key)] = this[key as keyof NotificationMessage];
      return acc;
    }, {});
  }
}
